module.exports = __webpack_public_path__ + "img/aitv.b2d633fe.png";